import { render } from "./TheFaq.vue?vue&type=template&id=2835e234"
import script from "./TheFaq.vue?vue&type=script&lang=js"
export * from "./TheFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__